import React from "react";
import s from "./styles.module.css";

export const DashboardCard = ({ children }) => {
  return <div className={s.card}>{children}</div>;
};
